import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { log } from 'console';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'smart-accounting-web';
  shouldRenderComponent = true;
  queryParams = {}
  isIframe = false

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService, private router: Router) {
    this.translate.setDefaultLang('en');
    this.translate.use(localStorage.getItem('lang') || 'en');
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Check the current route and determine if the component should be rendered
        this.shouldRenderComponent = !event.url.startsWith('/viberauth');
      }
    });
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
      this.isIframe = params.is_iframe == "true"
    });


  }
}
